module.exports = __webpack_public_path__ + "static/media/elizondo_harinadetrigo(1).e6e85710.png";